import * as React from 'react';

export const Checkbox: React.FC<{}> = () => {
	return <div className='checkbox'></div>;
};
